import { Link } from "react-router-dom";

export const renderNavItem = (
  basePath,
  filter,
  value,
  label,
  darkIcon,
  whiteIcon,
  altText,
) => {
  const isActive = filter === value;

  return (
    <Link
      to={`${basePath}?filter=${value}`} // Make sure this matches your new route
      className={`oferring-nav-item ${
        isActive ? "oferring-nav-item-active" : ""
      }`}
    >
      {/* Only render the image if icons are provided */}
      {darkIcon && whiteIcon && (
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/${
            isActive ? whiteIcon : darkIcon
          }`}
          alt={altText || label}
        />
      )}
      <span>{label}</span>
    </Link>
  );
};
